import React from 'react';
import { motion } from 'framer-motion';
import { Check, Truck, ShieldCheck, Leaf } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function CtaSection() {
  return <section className="w-full py-20 px-4 md:px-8 text-center relative overflow-hidden" data-id="element-16">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sage/30 rounded-full blur-3xl -z-10" data-id="element-17"></div>

      <div className="max-w-3xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-19">
          <h2 className="font-handwritten text-4xl md:text-6xl text-forestGreen font-bold mb-6" data-id="element-20">
            Schau nicht auf die Pfoten – schau auf den Darm
          </h2>

          <p className="font-serif text-lg md:text-xl text-gray-800 mb-6 max-w-2xl mx-auto" data-id="element-21">
            Teste das Magen-Darm-Topping jetzt risikofrei – mit
            Geld-zurück-Garantie.
          </p>

          <div className="flex items-center justify-center gap-1.5 mb-8 text-warmBrown/70 font-serif text-sm" data-id="element-22">
            <span className="text-warmBrown" data-id="element-23">★★★★</span>
            <span className="text-warmBrown/40" data-id="element-24">☆</span>
            <span className="ml-1" data-id="element-25">
              4,4/5 · 876 Hundehalter haben es bewertet
            </span>
          </div>

          <CtaButton label="Hilf auch deinem Hund — natürlich & sanft" position="bottom_cta" data-id="element-26" />

          <p className="text-[13px] text-warmBrown/60 italic text-center mt-6 font-serif" data-id="element-27">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-8 text-sm font-serif text-warmBrown/80" data-id="element-28">
            <span className="flex items-center gap-1.5" data-id="element-29">
              <Truck size={16} className="text-forestGreen" data-id="element-30" /> Schneller Versand
            </span>
            <span className="flex items-center gap-1.5" data-id="element-31">
              <ShieldCheck size={16} className="text-forestGreen" data-id="element-32" />{' '}
              Zufriedenheitsgarantie
            </span>
            <span className="flex items-center gap-1.5" data-id="element-33">
              <Leaf size={16} className="text-forestGreen" data-id="element-34" /> 100% Natürliche
              Inhaltsstoffe
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}